import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Text } from '@/components/ui/typography';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

const AudioPopup = ({ onClose, candidate }) => {
  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>
            Audio <span className="font-semibold">{candidate.name}</span> is a <span className={cn("font-semibold", candidate.Resume_Score >= 80 ? "text-green-600" : candidate.Resume_Score >= 50 ? "text-yellow-600" : "text-orange-600")}>{candidate.Resume_Score >= 80 ? "Great Match" : candidate.Resume_Score >= 50 ? "Good Match" : "Basic Match"}</span>
          </DialogTitle>
        </DialogHeader>
        <audio controls className="w-full">
          <source src="https://file-examples.com/storage/fe481ee8c941f7b3d4ccf0b/2017/11/file_example_MP3_700KB.mp3" type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      </DialogContent>
    </Dialog>
  );
};

export default AudioPopup;
